export const SAVE_TEAM_MEMBERS = "SAVE_TEAM_MEMBERS";
export const CLEAR_TEAM_MEMBERS = "CLEAR_TEAM_MEMBERS";

export const SAVE_ROLES_PERMISSIONS = "SAVE_ROLES_PERMISSIONS";
export const CLEAR_ROLES_PERMISSIONS = "CLEAR_ROLES_PERMISSIONS";
export const SAVE_ROLE_MODULES = "SAVE_ROLE_MODULES"

export const SAVE_STARTUP_PROFILE = "SAVE_STARTUP_PROFILE";
